import ShInput from './src/main.vue'

ShInput.install = Vue => {
  Vue.component(ShInput.name, ShInput)
}

export default ShInput
